import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router , ActivatedRoute} from '@angular/router';
import { SDGComponent, Result, ResultData, QuestionCategoryGroup, QuestionCategoryType, QuestionType } from '../_models/index';
import { AlertService, SDGComponentService, ResultService, SummaryService } from '../_services/index';
import { StatusService } from '../_services/status.service'
import { Observable } from 'rxjs/Observable';
import { Subscription } from 'rxjs/Subscription';
import { environment } from '../../environments/environment';
import * as GlobalVariables from '../sdg/globals/globals';
import * as html2canvas from 'html2canvas';
import * as jsPDF from 'jspdf';
import * as $ from 'jquery';
import { debug } from 'util';

@Component({
  selector: 'app-view-summary',
  templateUrl: './view-summary.component.html',
  styleUrls: ['./view-summary.component.css']
})

export class ViewSummaryComponent implements OnInit, OnDestroy {

  lang = 1;
  translation: any;
  is_country_fp = false;
  admin_url = environment.url_django;
  summaryColumns$ : Observable<any>;
  columnHeading: Array<any>;
  rowHeadings: Array<any>;
  objectKeys : Object;
  qcgToSSC : Object = {};

  drrResults$ : Observable<ResultData[]>;
  integrityResults$ : Observable<ResultData[]>;
  financeResults$ : Observable<ResultData[]>;
  policyResults$ : Observable<ResultData[]>;
  genderResults$ : Observable<ResultData[]>;
  capacityResults$ : Observable<ResultData[]>;

  subscription1:Subscription;
  subscription2:Subscription;
  subscription3:Subscription;
  subscription4:Subscription;
  subscription5:Subscription;
  subscription6:Subscription;
  subscription7:Subscription;
  subscription8:Subscription;

  summaryData : Object = {
    "Target": {
      "name": "Water-related SDG Targets",
      "span": 2,
      "subComponents": {"id":{},"targets":{}}
    },
    "Indicator": {
      "name": "Indicator",
      "span": 2,
      "subComponents": {"id":{}, "indicators":{}}
    },
//    "National Aspiration": {
//      "name": "National Aspiration",
//      "span": 1,
//      "subComponents": {
//        "Aspiration": {
//          "6.1.1": {}, "6.2.1": {}, "6.3.1": {}, "6.3.2": {}, "6.4.1": {},
//          "6.4.2": {}, "6.5.1": {}, "6.5.2": {}, "6.6.1": {}
//        }
//      }
//    },
//    "Status": {
//      "name": "Status",
//      "span": 1,
//      "subComponents": {
//        "% Goal":{
//          "6.1.1": {}, "6.2.1": {}, "6.3.1": {}, "6.3.2": {}, "6.4.1": {},
//          "6.4.2": {}, "6.5.1": {}, "6.5.2": {}, "6.6.1": {}
//        }
//      }
//    },
    "Capacity": {},
    "Finance": {},
    "Policy & Institutional": {},
    "Gender": {},
    "DRR/Resilience": {},
    "Integrity": {}
  };

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private sdgComponentService: SDGComponentService,
    private alertService: AlertService,
    private resultService: ResultService,
    private summaryService: SummaryService,
    private statusService: StatusService) { }

  ngOnInit() {
        var currentUserId = JSON.parse(localStorage.getItem('currentUserId'));
        if(currentUserId)
        this.is_country_fp = currentUserId.country_focal_point;

    this.lang = GlobalVariables.findTranslationOptionsIndex(window);
    this.translation = GlobalVariables.option_translations[this.lang];

    //this.no_evidence = this.translation["No evidence"]
    this.objectKeys = Object.keys;
    this.summaryColumns$ = this.summaryService.getAll();
    this.subscription1 = this.summaryColumns$.subscribe( data => {

        //console.log('data');
        //console.log(data);
        this.extractColumns(data);
        this.extractRows(data);
        this.calculateDRR();
        this.calculateIntegrity();
        this.calculateFinance();
        this.calculatePolicy();
        this.calculateGender();
        this.calculateCapacity();
//        this.calculateStatus();
      //  this.summaryData['Finance']['subComponents']
 this.summaryData['Finance']['subComponents']
 delete this.summaryData['Finance']['subComponents']['Accountability'];
      //console.log('this.summaryData');
      //console.log(this.summaryData);
      });
  }

  homeBtnClick(){
      this.router.navigateByUrl('/')
  }
  capacityBtnClick(){
      this.router.navigateByUrl('/sdg/capacity-resource')
  }
  statusBtnClick(){
      this.router.navigateByUrl('/sdg/status')
  }
  financeBtnClick(){
      this.router.navigateByUrl('/sdg/finance')
  }
  integrityBtnClick(){
      this.router.navigateByUrl('/sdg/transparency')
  }
  genderBtnClick(){
      this.router.navigateByUrl('/sdg/gender')
  }
  policyBtnClick(){
      this.router.navigateByUrl('/sdg/policy')
  }
  register1Click(){
      this.router.navigateByUrl('/register')
  }
  resilienceBtnClick(){
      this.router.navigateByUrl('/sdg/resilience')
  }
  logoutClick(){
    localStorage.setItem('editmode', '0');
    this.router.navigateByUrl('/login')
  }

  profileClick(){
    this.router.navigateByUrl('/profile')
  }
  feedbackClick(){
      this.router.navigateByUrl('/feedback')
  }
    manageTeamClick(){
        this.router.navigateByUrl('/manage-team')
    }
  extractColumns(data) {

      let tsch = data[2].tsch;
      for (let colm of tsch){
        let type, componentName, componentId;
        if (colm.question_category_type !== null){
          type = colm.question_category_type;
          this.qcgToSSC[type.category_group] = colm.display_text;
        }
        else if (colm.question_type !== null){
          type = colm.question_type.question_category_type;
          this.qcgToSSC[type.category_group] = colm.display_text;
        }
        componentName = type.component.name;
        componentId = type.component.id;

        if(componentName=='Gender Mainstreaming')
          componentName='Gender'
        if(componentName=='National Capacity')
          componentName='Capacity'
        this.summaryData[componentName]["id"] = componentId
        if (this.summaryData[componentName]["span"] === undefined)
          this.summaryData[componentName]["span"] = 1;
        else
          this.summaryData[componentName]["span"] += 1;
        if (this.summaryData[componentName]["subComponents"] === undefined) {

          this.summaryData[componentName]["subComponents"] = {}
          this.summaryData[componentName]["subComponents"][colm.display_text] = {
          "6.1.1": {}, "6.2.1": {}, "6.3.1": {}, "6.3.2": {}, "6.4.1": {},
          "6.4.2": {}, "6.5.1": {}, "6.5.2": {}, "6.6.1": {}
          }
        }
        else {
          this.summaryData[componentName]["subComponents"][colm.display_text] = {
          "6.1.1": {}, "6.2.1": {}, "6.3.1": {}, "6.3.2": {}, "6.4.1": {},
          "6.4.2": {}, "6.5.1": {}, "6.5.2": {}, "6.6.1": {}
          }
        }
      }
      this.columnHeading = Object.keys(this.summaryData);

  }
  extractRows(data){

    let targets = data[4].targets;
    let targets_ordered = [0,0,0,0,0,0];
    for(var i = 0; i< targets.length; i++){
      let indicators = targets[i].indicator;
      let indicators_ordered = [0];
      if(indicators.length == 2)
        indicators_ordered = [0,0];
      for(var j = 0; j < indicators.length; j++){
        indicators_ordered[indicators[j].order-1] = indicators[j];
      }
      targets[i].indicator = indicators_ordered;
      targets_ordered[targets[i].order-1] = targets[i];
    }

    this.rowHeadings = targets_ordered;
  }

  generateResultRevised(per_value_yes, per_value_no, per_value_dev, per_value_unknown){
    let result_obj = {
      "class":"",
      "result":""
    }
    var arr = [per_value_yes,per_value_no,per_value_dev,per_value_unknown]
    var indexOfMaxValue = arr.indexOf(Math.max(...arr));
    if (indexOfMaxValue == 0 ){                         //1. Yes, -> 0
      result_obj.class = "green"
      result_obj.result = this.translation["Adequate"]
    } else if(indexOfMaxValue == 1){                    //2. No, -> 1
      result_obj.class = "red"
      result_obj.result = this.translation["Inadequate"]
    } else if(indexOfMaxValue == 2){                    //3. In development, -> 2
      result_obj.class = "lightgreen"
      result_obj.result = this.translation["In progress"]
    } else if(indexOfMaxValue == 3){                    //4. Unknown -> 3
      result_obj.class = "noevidence"
      result_obj.result = this.translation["No evidence"]
    }
    return result_obj
  }

  generateStatusResult(avg_value){
    let result_obj = {
      "class":"",
      "result":""
    }
    if(avg_value==null || avg_value == '-Infinity' || Number.isNaN(parseFloat(avg_value)))
      result_obj.result = "Infinite Value";
    else{
      avg_value *= 100;
      result_obj.result = Math.round(avg_value).toString() + ' %';
    }

    if (avg_value === 9999 || avg_value === 999900 || isNaN(avg_value)){
      result_obj.class = "blue"
      result_obj.result = this.translation["No evidence"]
    } else if(avg_value == 100){
      result_obj.class = "green"
    } else if(avg_value > 66){
      result_obj.class = ""
    } else if(avg_value >= 0){
      result_obj.class = "red"
    }
    return result_obj
  }

  generateNationalAspirationResult(avg_value, sub_category){
    let result_obj = {
      "class":"",
      "result":""
    }
    avg_value *= 100;
    avg_value = Math.round( avg_value )
    if (avg_value === 9999 || avg_value === 999900 || isNaN(avg_value)){
      result_obj.result = "No aspiration"
    } else if(sub_category === "6.1.1"){
      result_obj.result = avg_value + "% of population using safely managed drinking water services"
    } else if(sub_category === "6.2.1"){
      result_obj.result = avg_value + "% of population using safely managed sanitation and hand-washing services"
    } else if(sub_category === "6.3.1"){
      result_obj.result = avg_value + "% of wastewater safely treated"
    } else if(sub_category === "6.3.2"){
      result_obj.result = avg_value + "% of water bodies with good ambient water quality"
    } else if(sub_category === "6.4.1"){
      result_obj.result = avg_value + "% change in water use efficiency"
    } else if(sub_category === "6.4.2"){
      result_obj.result = avg_value + "% reduction in freshwater withdrawal compared to available freshwater resources"
    } else if(sub_category === "6.5.1"){
      result_obj.result = avg_value + "% achievement of IWRM implementation"
    } else if(sub_category === "6.5.2"){
      result_obj.result = avg_value + "% of transboundary basin area with an operational arrangement for water cooperation"
    } else if(sub_category === "6.6.1"){
      result_obj.result = avg_value + "% change in the extent of water-related ecosystems"
    }
    return result_obj
  }
  // ==========================DRR==============================
  calculateDRR(){
    let drr_comp = environment.component.resilience;
    this.drrResults$ = this.resultService.getSummaryResults(drr_comp);
    this.subscription2 = this.drrResults$.subscribe(
      data => {
        let curr_qcat_type_name;
        let obj = {"perc_yes": 0, "perc_no": 0, "perc_unknown": 0, "perc_dev": 0},
        obj1 = {"perc_yes": 0, "perc_no": 0, "perc_unknown": 0, "perc_dev": 0},
        obj2 = {"perc_yes": 0, "perc_no": 0, "perc_unknown": 0, "perc_dev": 0};
        for(let row of data){
          curr_qcat_type_name = row.question_category_type_name;
          if(curr_qcat_type_name=='r1'||curr_qcat_type_name=='r2'||curr_qcat_type_name=='r4'){
            this.calculateDRRStrategies(row, obj);
          }
          else if(curr_qcat_type_name=='r8'){
            this.calculateDRRAssessments(row, obj1);
          }
          else if(curr_qcat_type_name=='r3'){
            this.calculateDRRInfrastructure(row, obj2);
          }
        }
      });
  }
  calculateDRRStrategies(resobj, obj){

    if(resobj.value_weight == 1)                //yes
      obj.perc_yes++;

    else if(resobj.value_weight == 2)           //no
      obj.perc_no++;
    else if(resobj.value_weight == 3)           //Unknown
      obj.perc_unknown++;
    else if(resobj.value_weight == 4)           //Indevelopment
      obj.perc_dev++;

    //terminating condition
    if (resobj.question_category_type_name == 'r4'){
      let sub_category = String(resobj.sub_category)
      sub_category = sub_category.substring(1);
      Object.keys(obj).forEach(function(key) {
        obj[key]=obj[key]/3;
      });
      let result = this.generateResultRevised(obj.perc_yes, obj.perc_no,obj.perc_dev, obj.perc_unknown);
      obj.perc_dev=0;
      obj.perc_no=0;
      obj.perc_unknown=0;
      obj.perc_yes=0;
      let qcg = this.qcgToSSC["Disaster Risk Reduction Strategies"];
      if(qcg !== undefined)
        this.summaryData["DRR/Resilience"]["subComponents"][qcg][sub_category] = result;
    }
  }
  calculateDRRAssessments(resobj, obj){

    if(resobj.value_weight == 1)                //yes
      obj.perc_yes++;
    else if(resobj.value_weight == 2)           //no
      obj.perc_no++;
    else if(resobj.value_weight == 3)           //Unknown
      obj.perc_unknown++;
    else if(resobj.value_weight == 4)           //Indevelopment
      obj.perc_dev++;

    //terminating condition
      let sub_category = String(resobj.sub_category)
      sub_category = sub_category.substring(1);
      let result = this.generateResultRevised(obj.perc_yes, obj.perc_no,obj.perc_dev, obj.perc_unknown);
      obj.perc_dev=0;
      obj.perc_no=0;
      obj.perc_unknown=0;
      obj.perc_yes=0;
      let qcg = this.qcgToSSC["Infrastructure"];
      if(qcg !== undefined)
        this.summaryData["DRR/Resilience"]["subComponents"][qcg][sub_category] = result;
  }
  calculateDRRInfrastructure(resobj, obj){

    if(resobj.value_weight == 1)
                    //yes
      obj.perc_yes++;

    else if(resobj.value_weight == 2)           //no
      obj.perc_no++;
    else if(resobj.value_weight == 3)           //Unknown
      obj.perc_unknown++;
    else if(resobj.value_weight == 4)           //Indevelopment
      obj.perc_dev++;

    //terminating condition
      let sub_category = String(resobj.sub_category)
      sub_category = sub_category.substring(1);
      let result = this.generateResultRevised(obj.perc_yes, obj.perc_no,obj.perc_dev, obj.perc_unknown);
      obj.perc_dev=0;
      obj.perc_no=0;
      obj.perc_unknown=0;
      obj.perc_yes=0;
      let qcg = this.qcgToSSC["Disaster Risk Information and Assessments"];
      if(qcg !== undefined)
        this.summaryData["DRR/Resilience"]["subComponents"][qcg][sub_category] = result;
    }
  // ==========================Integrity==============================
  calculateIntegrity(){
    let integrity_comp = environment.component.transparency;
    this.integrityResults$ = this.resultService.getSummaryResults(integrity_comp);
    this.subscription3 = this.integrityResults$.subscribe(
      data => {
        let curr_qcat_type_name, curr_qtype_name;
        //Memorization
        let obj = {"perc_yes": 0, "perc_no": 0, "perc_unknown": 0, "perc_dev": 0},
        obj1 = {"perc_yes": 0, "perc_no": 0, "perc_unknown": 0, "perc_dev": 0},
        obj2 = {"perc_yes": 0, "perc_no": 0, "perc_unknown": 0, "perc_dev": 0};

        for(let row of data){
          curr_qcat_type_name = row.question_category_type_name; //t5
          curr_qtype_name = row.question_type_name //5a
          if(["t1a","t7a","t4a"].indexOf(curr_qtype_name) > -1){
            this.calculatePolicyIntegrity(row, obj);
          }
          else if(["t2a"].indexOf(curr_qtype_name) > -1){
            this.calculatePublicSector(row, obj1);
          }
          else if(["t3a"].indexOf(curr_qtype_name) > -1){
            this.calculateWBProtection(row, obj2);
          }
        }
      });
  }

  calculatePolicyIntegrity(resobj, obj){

    if(resobj.value_weight == 1)                //yes
      obj.perc_yes++;
    else if(resobj.value_weight == 2)           //no
      obj.perc_no++;
    else if(resobj.value_weight == 3)           //Unknown
      obj.perc_unknown++;
    else if(resobj.value_weight == 4)           //Indevelopment
      obj.perc_dev++;

    //terminating condition
    if (resobj.question_type_name == 't7a'){
      let sub_category = String(resobj.sub_category)
      sub_category = sub_category.substring(1);
      Object.keys(obj).forEach(function(key) {
        obj[key]=obj[key]/3;
      });
      let result = this.generateResultRevised(obj.perc_yes, obj.perc_no,obj.perc_dev, obj.perc_unknown);
      obj.perc_dev=0;
      obj.perc_no=0;
      obj.perc_unknown=0;
      obj.perc_yes=0;
      let qcg = this.qcgToSSC[resobj.question_category_group]
      if(qcg !== undefined)
        this.summaryData["Integrity"]["subComponents"][qcg][sub_category] = result;
    }
  }
  calculatePublicSector(resobj, obj){
    if(resobj.value_weight == 1)                //yes
      obj.perc_yes++;
    else if(resobj.value_weight == 2)           //no
      obj.perc_no++;
    else if(resobj.value_weight == 3)           //Unknown
      obj.perc_unknown++;
    else if(resobj.value_weight == 4)           //Indevelopment
      obj.perc_dev++;

    //terminating condition
      let sub_category = String(resobj.sub_category)
      sub_category = sub_category.substring(1);
      let result = this.generateResultRevised(obj.perc_yes, obj.perc_no,obj.perc_dev, obj.perc_unknown);
      obj.perc_dev=0;
      obj.perc_no=0;
      obj.perc_unknown=0;
      obj.perc_yes=0;
      let qcg = this.qcgToSSC["Public Sector Integrity"];
      if(qcg !== undefined)
        this.summaryData["Integrity"]["subComponents"][qcg][sub_category] = result;

  }

  calculateWBProtection(resobj, obj){

    if(resobj.value_weight == 1)                //yes
      obj.perc_yes++;
    else if(resobj.value_weight == 2)           //no
      obj.perc_no++;
    else if(resobj.value_weight == 3)           //Unknown
      obj.perc_unknown++;
    else if(resobj.value_weight == 4)           //Indevelopment
      obj.perc_dev++;

    //terminating condition
      let sub_category = String(resobj.sub_category)
      sub_category = sub_category.substring(1);
      let result = this.generateResultRevised(obj.perc_yes, obj.perc_no,obj.perc_dev, obj.perc_unknown);
      obj.perc_dev=0;
      obj.perc_no=0;
      obj.perc_unknown=0;
      obj.perc_yes=0;
      let qcg = this.qcgToSSC['Whistle-blower Protection'];
      if(qcg !== undefined)
        this.summaryData["Integrity"]["subComponents"][qcg][sub_category] = result;
    }
  // ==========================Finance==============================

  calculateFinanceAdequacy(resobj, curr_qcat_name, obj){
    if(resobj.value_weight == 1)           //yes
      obj.perc_yes++;
    else if(resobj.value_weight == 2)           //no
      obj.perc_no++;
    else if(resobj.value_weight == 3)           //Unknown
      obj.perc_unknown++;
    else if(resobj.value_weight == 4)           //Indevelopment
      obj.perc_dev++;

    //terminating condition
    if (curr_qcat_name == 'f18'){
      let sub_category = String(resobj.sub_category)
      sub_category = sub_category.substring(1);
      Object.keys(obj).forEach(function(key) {
        obj[key]=obj[key]/2;
      });
      let result = this.generateResultRevised(obj.perc_yes, obj.perc_no,obj.perc_dev, obj.perc_unknown);
      obj.perc_dev=0;
      obj.perc_no=0;
      obj.perc_unknown=0;
      obj.perc_yes=0;
      obj.total=0;
      let qcg = this.qcgToSSC[resobj.question_category_group]
      if(qcg !== undefined)

        this.summaryData["Finance"]["subComponents"][qcg][sub_category] = result;
    }
  }
  calculateFinanceSources(resobj,obj,curr_qcat_name){

    if(resobj.value_weight == 1)           //yes
      obj.perc_yes++;
    else if(resobj.value_weight == 2)           //no
      obj.perc_no++;
    else if(resobj.value_weight == 3)           //Unknown
      obj.perc_unknown++;
    else if(resobj.value_weight == 4)           //Indevelopment
      obj.perc_dev++;

    //terminating condition
      let sub_category = String(resobj.sub_category)
      sub_category = sub_category.substring(1);
      let result = this.generateResultRevised(obj.perc_yes, obj.perc_no,obj.perc_dev, obj.perc_unknown);
      obj.perc_dev=0;
      obj.perc_no=0;
      obj.perc_unknown=0;
      obj.perc_yes=0;
      obj.total=0;
      let qcg = this.qcgToSSC[resobj.question_category_group]
      if(qcg !== undefined)
        this.summaryData["Finance"]["subComponents"][qcg][sub_category] = result;

}
  calculateFinanceEquity(resobj, obj){

    if(resobj.value_weight == 1)                //yes
      obj.perc_yes++;
    else if(resobj.value_weight == 2)           //no
      obj.perc_no++;
    else if(resobj.value_weight == 3)           //Unknown
      obj.perc_unknown++;
    else if(resobj.value_weight == 4)           //Indevelopment
      obj.perc_dev++;

    //terminating condition

      let sub_category = String(resobj.sub_category)
      sub_category = sub_category.substring(1);
      let result = this.generateResultRevised(obj.perc_yes, obj.perc_no,obj.perc_dev, obj.perc_unknown);
      obj.perc_dev=0;
      obj.perc_no=0;
      obj.perc_unknown=0;
      obj.perc_yes=0;
      obj.total=0;
      let qcg = this.qcgToSSC[resobj.question_category_group]
      if(qcg !== undefined)
        this.summaryData["Finance"]["subComponents"][qcg][sub_category] = result;

  }
  calculateFinance(){
    let finance_comp = environment.component.finance;
    this.financeResults$ = this.resultService.getSummaryResults(finance_comp);
    this.subscription4 = this.financeResults$.subscribe(
      data => {
        let curr_qcat_name = "",
        curr_qtype_name ="",

        //Memorization
        obj = {"perc_yes": 0, "perc_no": 0, "perc_unknown": 0, "perc_dev": 0},
        obj1 = {"perc_yes": 0, "perc_no": 0, "perc_unknown": 0, "perc_dev": 0},
        obj2 = {"perc_yes": 0, "perc_no": 0, "perc_unknown": 0, "perc_dev": 0},
        obj3 = {"perc_yes": 0, "perc_no": 0, "perc_unknown": 0, "perc_dev": 0};

        for(let row of data){


          curr_qcat_name = row.question_category_type_name;
         curr_qtype_name = row.question_type_name;
          if(
            curr_qcat_name == "f5"|| curr_qcat_name == "f18")
          {
            this.calculateFinanceAdequacy(row, curr_qcat_name, obj);
          }
           else if(curr_qcat_name == 'f12' || curr_qcat_name=='f17')
          {
            this.calculateFinanceSources(row,obj2,curr_qcat_name);
          }
          else if(curr_qcat_name == 'f19'){
            this.calculateFinanceEquity(row, obj3)
          }
        }
      });
  }
  // ==========================Policy & Institutional==============================
  calculatePolicyEquity(row, curr_qtype_name, perc_ans){


      if(row.value_weight == 1)           //Adequate > Yes
        perc_ans.perc_yes++;
      else if(row.value_weight == 2)      //In-Adequate > No
        perc_ans.perc_no++;
      else if(row.value_weight == 3)      //Unknown
        perc_ans.perc_unknown++;
      else if(row.value_weight == 4)      //In developement
        perc_ans.perc_dev++;
        //terminating condition oo
      if(curr_qtype_name=='5a'){
        let sub_category = String(row.sub_category)
      sub_category = sub_category.substring(1);
      Object.keys(perc_ans).forEach(function(key) {
        row[key]=row[key]/3;
      });

        let result = this.generateResultRevised(perc_ans.perc_yes,perc_ans.perc_no,perc_ans.perc_dev,perc_ans.perc_unknown);
        perc_ans.perc_unknown=0;
        perc_ans.perc_yes=0;
        perc_ans.perc_dev=0;
        perc_ans.perc_no=0;
        let qcg = this.qcgToSSC[row.question_category_group]
        if(qcg !== undefined)
          this.summaryData["Policy & Institutional"]["subComponents"][qcg][sub_category] = result;
      }

  }

  calculatePolicyAwareness(row, curr_qtype_name, perc_ans){
    // let response_value;
    if (curr_qtype_name == '14a'){
    if(row.value_weight == 1)           //Adequate > Yes
      perc_ans.perc_yes=100;
    else if(row.value_weight == 2)      //In-Adequate > No
      perc_ans.perc_no=100;
    else if(row.value_weight == 3)
      perc_ans.perc_unknown=100;          //None > Unknown
    else if(row.value_weight == 4)
    //In development > In development
     perc_ans.perc_dev=100;
      let sub_category = String(row.sub_category)
      sub_category = sub_category.substring(1);
      let result = this.generateResultRevised(perc_ans.perc_yes,perc_ans.perc_no,perc_ans.perc_dev,perc_ans.perc_unknown);
      perc_ans.perc_unknown=0;
      perc_ans.perc_yes=0;
      perc_ans.perc_dev=0;
      perc_ans.perc_no=0;
      let qcg = this.qcgToSSC[row.question_category_group]
      //console.log('qcg2',qcg);
      if(qcg !== undefined)
        this.summaryData["Policy & Institutional"]["subComponents"][qcg][sub_category] = result;
    }
  }

  calculatePolicyCoordination(row, curr_qtype_name, perc_ans){
      if(row.value_weight == 1)           //Yes
        perc_ans.perc_yes++;
      else if(row.value_weight == 2)      //No
        perc_ans.perc_no++;
      else if(row.value_weight == 3)      //Unknown
        perc_ans.perc_unknown++;
      else if(row.value_weight == 4)      //In development
        perc_ans.perc_dev++;
        if(curr_qtype_name=='11a'){
          let sub_category = String(row.sub_category)
        sub_category = sub_category.substring(1);
        Object.keys(perc_ans).forEach(function(key) {
          row[key]=row[key]/3;
        });
        let result = this.generateResultRevised(perc_ans.perc_yes,perc_ans.perc_no,perc_ans.perc_dev,perc_ans.perc_unknown);
      perc_ans.perc_unknown=0;
      perc_ans.perc_yes=0;
      perc_ans.perc_dev=0;
      perc_ans.perc_no=0;
      let qcg = this.qcgToSSC[row.question_category_group]
      if(qcg !== undefined)
        this.summaryData["Policy & Institutional"]["subComponents"][qcg][sub_category] = result;
    }
  }

  calculatePolicy(){
    let policy_comp = environment.component.policy;
    this.policyResults$ = this.resultService.getSummaryResults(policy_comp);
    this.subscription5 = this.policyResults$.subscribe(
      data => {

        //Memorization variables
        let perc_ans2 = {
          "perc_yes":0,
          "perc_no":0,
          "perc_unknown":0,
          "perc_dev":0
        },
        perc_ans = {
          "perc_yes":0,
          "perc_no":0,
          "perc_unknown":0,
          "perc_dev":0
        },
        perc_ans1 = {
          "perc_yes":0,
          "perc_no":0,
          "perc_unknown":0,
          "perc_dev":0
        },
        curr_qcat_name = '', curr_qtype_name = '';
        for(let row of data){
          curr_qcat_name = row.question_category_type_name;
          curr_qtype_name = row.question_type_name;
          if(curr_qtype_name == '3a'||curr_qtype_name == '5a'||curr_qtype_name=='8a'){
              this.calculatePolicyEquity(row, curr_qtype_name, perc_ans2);
          }
          else if(curr_qtype_name == '6a'||curr_qtype_name == '9a'||curr_qtype_name == '10a'||curr_qtype_name == '11a'){
            this.calculatePolicyCoordination(row, curr_qtype_name, perc_ans);
          }
          else if(curr_qtype_name == '14a'){
            this.calculatePolicyAwareness(row, curr_qtype_name, perc_ans1)
          }
        }
      });
  }

  // ==========================Gender Mainstreaming==============================

    calculateGenderPolicy(resobj, obj){

    if(resobj.value_weight == 1)           //yes
      obj.perc_yes++;
    else if(resobj.value_weight == 2)           //no
      obj.perc_no++;
    else if(resobj.value_weight == 3)           //Unknown
      obj.perc_unknown++;
    else if(resobj.value_weight == 4)           //Indevelopment
      obj.perc_dev++;
    //terminating condition
     let sub_category = String(resobj.sub_category);
      sub_category = sub_category.substring(1);
      let result = this.generateResultRevised(obj.perc_yes, obj.perc_no,obj.perc_dev, obj.perc_unknown);
      obj.perc_dev=0;
      obj.perc_no=0;
      obj.perc_unknown=0;
      obj.perc_yes=0;
      let qcg = this.qcgToSSC[resobj.question_category_group];
       //National Policy
      if(qcg !== undefined)
          this.summaryData["Gender"]["subComponents"][qcg][sub_category] = result;

      }


  calculateGenderGovernancy(resobj, obj){

    if(resobj.value_weight == 1)           //yes
      obj.perc_yes++;
    else if(resobj.value_weight == 2)           //no
      obj.perc_no++;
    else if(resobj.value_weight == 3)           //Unknown
      obj.perc_unknown++;
    else if(resobj.value_weight == 4)           //Indevelopment
      obj.perc_dev++;
    //terminating condition
    if (resobj.question_type_name == 'g3a'){
      let sub_category = String(resobj.sub_category)
      sub_category = sub_category.substring(1);
      Object.keys(obj).forEach(function(key) {
        obj[key]=obj[key]/3;
      });
      let result = this.generateResultRevised(obj.perc_yes, obj.perc_no,obj.perc_dev, obj.perc_unknown);
      obj.perc_dev=0;
      obj.perc_no=0;
      obj.perc_unknown=0;
      obj.perc_yes=0;
      let qcg = this.qcgToSSC[resobj.question_category_group];
       //Governance
      if(qcg !== undefined)
          this.summaryData["Gender"]["subComponents"][qcg][sub_category] = result;

      }
  }
  calculateGenderTraining(row,obj){
    if(row.value_weight == 1)                //yes
      obj.perc_yes++;
    else if(row.value_weight == 3)           //unknown
      obj.perc_unknown++;
    else if(row.value_weight == 4)           //In-development
      obj.perc_dev++;
    else if(row.value_weight == 2)           // No
      obj.perc_no++;
    //terminating condition
    if (row.question_category_type_name == 'g4_new'){
      let sub_category = String(row.sub_category)
      sub_category = sub_category.substring(1);
      Object.keys(obj).forEach(function(key) {
        obj[key]=obj[key]/2;
      });

    let result = this.generateResultRevised(obj.perc_yes, obj.perc_no, obj.perc_dev, obj.perc_unknown);
    obj.perc_unknown=0;
    obj.perc_yes=0;
    obj.perc_dev=0;
    obj.perc_no=0;
    let qcg = this.qcgToSSC['Organizations'];
     //Organisation mainstreaming
    if(qcg !== undefined)
      this.summaryData["Gender"]["subComponents"][qcg][sub_category] = result;
  }
}
  calculateGender(){
    let gender_comp = environment.component.gender;
    this.genderResults$ = this.resultService.getSummaryResults(gender_comp);
    this.subscription5 = this.genderResults$.subscribe(
      data => {

        //Memorization
        let value_obj1 = {"perc_yes":0, "perc_unknown": 0, "perc_dev": 0, "perc_no":0},
        value_obj2 = {"perc_yes":0, "perc_unknown": 0, "perc_dev": 0, "perc_no":0},
        value_obj3 = {"perc_yes":0, "perc_unknown": 0, "perc_dev": 0, "perc_no":0};
        for(let row of data){
          let resobj = row;
          let curr_qcat_name = row.question_category_type_name;
          let curr_qtype_name = row.question_type_name;
          if(curr_qcat_name == "g4" ){
            this.calculateGenderPolicy(resobj, value_obj1);
          }
          else if(curr_qtype_name == "g1a"||curr_qtype_name == "g2a"||curr_qtype_name=='g3a'){
            this.calculateGenderGovernancy(resobj, value_obj2)
          }
          else if (curr_qtype_name == "g4_new"||curr_qtype_name == "g5a") {
            this.calculateGenderTraining(resobj,value_obj3);
          }
        }
      });
  }


  // ==========================National Capacity==============================
  calculateCapacity(){
    let capacity_comp = environment.component.capacity;
    this.genderResults$ = this.resultService.getSummaryResults(capacity_comp);
    this.subscription6 = this.genderResults$.subscribe( data => {

        //Memorization
        let value_obj1 = {"perc_yes":0, "perc_unknown": 0, "perc_dev": 0, "perc_no":0},
        value_obj2 = {"perc_yes":0, "perc_unknown": 0, "perc_dev": 0, "perc_no":0},
        value_obj3 = {"perc_yes":0, "perc_unknown": 0, "perc_dev": 0, "perc_no":0};


        for(let row of data){
          let resobj = row;
          let curr_qcat_name = row.question_category_type_name;
          let curr_qtype_name = row.question_type_name;
          if(curr_qtype_name == "Human skills"){
            this.calculateCapacityOverall(row,value_obj1);
          }
          else if(curr_qtype_name == 'Value'){
              this.calculateCapacityStrengthening(resobj,value_obj2);
          }
          else if(curr_qtype_name == 'Private sector collaboration'){
            this.calculateCapacityProgress(resobj,value_obj3)

          }
        }
      });
  }
  calculateCapacityOverall(row,obj){

    if(row.value_weight == 1)           //yes -> complete capacity
      obj.perc_yes++;
    else if(row.value_weight == 2)           //unknown -> unknown
      obj.perc_no++;
    else if(row.value_weight == 3)           //In-development-> partial capacity
      obj.perc_unknown++;
    else if(row.value_weight == 4)
      obj.perc_dev++;
    //After terminating condition
    let sub_category = String(row.sub_category)
    sub_category = sub_category.substring(1);
    let result = this.generateResultRevised(obj.perc_yes, obj.perc_no, obj.perc_dev, obj.perc_unknown);
    obj.perc_unknown=0;
    obj.perc_yes=0;
    obj.perc_dev=0;
    obj.perc_no=0;
    let qcg = this.qcgToSSC[row.question_category_group]
    if(qcg !== undefined)
      this.summaryData["Capacity"]["subComponents"][qcg][sub_category] = result;
  }
  calculateCapacityStrengthening(resobj, obj){


    if(resobj.value_weight == 1)           //yes
      obj.perc_yes++;
    else if(resobj.value_weight == 2)           //no
      obj.perc_no++;
    else if(resobj.value_weight == 3)           //Unknown
      obj.perc_unknown++;
    else if(resobj.value_weight == 4)           //Indevelopment
      obj.perc_dev++;
    //terminating condition

      let sub_category = String(resobj.sub_category)
      sub_category = sub_category.substring(1);
      let result = this.generateResultRevised(obj.perc_yes, obj.perc_no,obj.perc_dev, obj.perc_unknown);
      obj.perc_dev=0;
      obj.perc_no=0;
      obj.perc_unknown=0;
      obj.perc_yes=0;
      let qcg = this.qcgToSSC[resobj.question_category_group]
      if(qcg !== undefined)
        this.summaryData["Capacity"]["subComponents"][qcg][sub_category] = result;
    }

  calculateCapacityProgress(resobj,obj){

    if(resobj.value_weight == 1)           //yes
      obj.perc_yes++;
    else if(resobj.value_weight == 2)           //no
      obj.perc_no++;
    else if(resobj.value_weight == 3)           //Unknown
      obj.perc_unknown++;
    else if(resobj.value_weight == 4)           //Indevelopment
      obj.perc_dev++;

    //terminating condition
      let sub_category = String(resobj.sub_category)
      sub_category = sub_category.substring(1);
      let result = this.generateResultRevised(obj.perc_yes, obj.perc_no,obj.perc_dev, obj.perc_unknown);
      obj.perc_dev=0;
      obj.perc_no=0;
      obj.perc_unknown=0;
      obj.perc_yes=0;
      let qcg = this.qcgToSSC[resobj.question_category_group]
      if(qcg !== undefined)
        this.summaryData["Capacity"]["subComponents"][qcg][sub_category] = result;
    }


  // ==========================Status==============================
  calculateStatus(){
    this.subscription7 = this.statusService.prepareForStatusResult().subscribe(
      data => {
        this.subscription8 = this.statusService.calculateStatusResult(data).subscribe(
          data => {
            let count  = 0;
            for (let row of data){
              if (row.percent_of_2030 != undefined && row.nasiv != undefined && count < 9){
                count ++;
                let sub_category = row.qcat.slice(0,5);
                let result_2030 = this.generateStatusResult(row.percent_of_2030);
                let result_nasiv = this.generateNationalAspirationResult(row.nasiv, sub_category)
                this.summaryData["Status"]["subComponents"]["% Goal"][sub_category] = result_2030;
                this.summaryData["National Aspiration"]["subComponents"]["Aspiration"][sub_category] = result_nasiv;

              }
            }
          });
      });
  }

  ngOnDestroy() {
  if(this.subscription1)
    this.subscription1.unsubscribe();
  if(this.subscription2)
    this.subscription2.unsubscribe();
  if(this.subscription3)
    this.subscription3.unsubscribe();
  if(this.subscription4)
    this.subscription4.unsubscribe();
  if(this.subscription5)
    this.subscription5.unsubscribe();
  if(this.subscription6)
    this.subscription6.unsubscribe();
  if(this.subscription7)
    this.subscription7.unsubscribe();
  if(this.subscription8)
    this.subscription8.unsubscribe();
}

  // ==========================Generate PDF==============================
  generatePDF(){
    let doc = new jsPDF('landscape');
    html2canvas(document.querySelector("#summaryTable")).then(canvas => {
      // Heading background
      doc.setDrawColor(0)
      doc.setFillColor(31,73,125)
      doc.rect(10, 10, 110, 8, 'F')
      //Heading
      doc.setTextColor(255,255,255)
      doc.setFontSize(8)
      doc.text(15, 15, 'SUMMARY VIEW: SUSTAINABLE DEVELOPMENT GOAL 6, EVIDENCE BASE')
      // Summary Table
      let height = (297 * canvas.height)/canvas.width
      let y = (210/2) - (height/2)
      doc.addImage(canvas.toDataURL("image/jpeg"), "JPEG",0,y,297,height);
      doc.save('SummaryReport.pdf');
    });
  }
    profileIconClick(){
    $('.dropdown-content').slideToggle(400, 'swing');
  }

  doTranslate(key: string){
      return this.translation[key]
  }
}



// WEBPACK FOOTER //
// ./src/app/view-summary/view-summary.component.ts